import { createFileRoute, Navigate, redirect } from "@tanstack/react-router";
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";
import { AdminPageLayout } from "@/features/admin/components/AdminPageLayout";
import { TrainersListPage } from "@/features/admin/trainers/TrainersListPage";
import { fetchFeatureFlags } from "@/hooks/useFeatureFlags";
import { usePermissions } from "@/hooks/usePermissions";

export const Route = createFileRoute("/admin/trainers")({
  // Trainers are hidden while the ilt flag is off (the API 404s them too).
  beforeLoad: async () => {
    const { ilt } = await fetchFeatureFlags();
    if (!ilt) throw redirect({ to: "/admin" });
  },
  component: TrainersRoute,
});

/** Trainers and their performance (LMS-144), for admins with Users.Read and Analytics.Read. */
function TrainersRoute() {
  const { hasPermission } = usePermissions();

  return (
    // ProtectedRoute lets in anyone with ANY of the permissions OR the role; the page needs both
    // permissions, which can be taken off any role, so it checks each of them again.
    <ProtectedRoute
      requiredPermissions={["Users.Read", "Analytics.Read"]}
      requiredRoles={["Admin"]}
    >
      {hasPermission("Users.Read") && hasPermission("Analytics.Read") ? (
        <AdminPageLayout mainClassName="bg-secondary_alt">
          <TrainersListPage />
        </AdminPageLayout>
      ) : (
        <Navigate to="/admin" />
      )}
    </ProtectedRoute>
  );
}
